module.exports = __webpack_public_path__ + "media/images/photos/13-60a92636db78a0d4e86093cdf18bc339.jpg";